/**
 * The reads Home paints (issue #794): the seat projection, which carries the
 * ranked act and the attention register (`use-seat-workspace`), and the week
 * register's two reads, the seat's courses and each course's classes
 * (`use-teaching-week`).
 *
 * Every act whose result Home shows (a roll, a class plan's publication, a
 * judgement, a recording's notice, publication or withdrawal) refreshes them
 * through this one helper, the way `course-query-keys.ts` holds the course
 * write's keys, so no act site carries its own copy to drift.
 *
 * A read nobody is watching is DROPPED, not invalidated: an invalidated read
 * still paints its old data on the next mount while it refetches, and Home must
 * never show the state from before the act. A read a page is watching (the
 * course workspace and the session index read the classes too) is invalidated
 * instead, so it refetches in place and nothing on screen is blanked.
 */
import type { QueryClient } from "@tanstack/react-query";

export const HOME_QUERY_KEY_PREFIXES = [
  ["seat-workspace"],
  ["session-index-courses"],
  ["course-workspace-sessions"],
] as const;

export function refreshHomeAfterAct(queryClient: QueryClient) {
  for (const queryKey of HOME_QUERY_KEY_PREFIXES) {
    queryClient.removeQueries({ queryKey, type: "inactive" });
    void queryClient.invalidateQueries({ queryKey, type: "active" });
  }
}
